<template>
  <a-drawer
    :title="title"
    placement="bottom"
    :visible="visible"
    height="60%"
    wrapClassName="wrapClassName"
    @close="onClose"
  >
    <a-table
      ref="assetTable_children"
      bordered
      class="assetTable_children"
      id="assetTable_children"
      :pagination="pagination"
      :rowKey="record => record.id"
      :columns="tableData.columns"
      :dataSource="tableData.data"
      :loading="tableData.loading"
      @change="handleTableChange"
      :rowSelection="{columnWidth: 40, selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
      :expanded-row-keys.sync="expandedRowKeys"
      :scroll="{ y: 'calc(100% - 42px)', x: scrollX }"
      :expandIconColumnIndex="2"
      :customRow="changeRow"
      :indentSize="20"
      :rowClassName="rowClassName"
    >
      <template slot="relevantdeptname" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">{{ record.relevantdeptname }}</template>
          <span class="assetNameTable">{{ record.relevantdeptname }}</span>
        </a-tooltip>
      </template>
      <!--      使用部门-->
      <template slot="usedeptname" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">{{ record.usedeptname }}</template>
          <span class="assetNameTable">{{ record.usedeptname }}</span>
        </a-tooltip>
      </template>
      <!--      部门使用人-->
      <template slot="principalName" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">{{ record.principalName }}</template>
          <span class="assetNameTable">{{ record.principalName }}</span>
        </a-tooltip>
      </template>
      <!--      规格型号-->
      <template slot="specification" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">{{ record.specification }}</template>
          <span class="assetNameTable">{{ record.specification }}</span>
        </a-tooltip>
      </template>
      <!--      设备状态-->
      <template slot="equipmentStatusName" slot-scope="text, record">
        <span class="blueIcon padding-1-8">{{ record.equipmentStatusName }}</span>
      </template>
      <!--      特性-->
      <template slot="peculiarity" slot-scope="text, record">
        <a-tooltip placement="top" v-if="record.isYlrqPeculiarity">
          <template slot="title">压力容器</template>
          <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #08409F80; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #08409FFF">压</span>
        </a-tooltip>
        <a-tooltip placement="top" v-if="record.isTzsbPeculiarity">
          <template slot="title">特种设备</template>
          <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B80; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">特</span>
        </a-tooltip>
        <a-tooltip placement="top" v-if="record.isHbPeculiarity">
          <template slot="title">环保特性</template>
          <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #36BF7D80; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #36BF7DFF">环</span>
        </a-tooltip>
      </template>
      <template slot="actions2" slot-scope="text, record">
        <span>×</span>
      </template>
      <template slot="actions3" slot-scope="text, record">
        <span>×</span>
      </template>
      <template slot="actions4" slot-scope="text, record">
        <span>{{ record.pnode ? '√' : '×' }}</span>
      </template>
      <template slot="actions5" slot-scope="text, record">
        <span>{{ (record.pid === '0' || record.pid === null || record.pid === true) ? '×' : '√' }}</span>
      </template>
      <template slot="actions6" slot-scope="text, record">
        <span class="orgIcon">故</span>
      </template>
      <template slot="actions7" slot-scope="text, record" style="background-color: red;">
        <span class="redIcon">即</span>
      </template>
    </a-table>
    <drawer-edit ref="drawerEdit" @getTableData="getTableData"></drawer-edit>
    <drawer-detail ref="drawerDetail" :disabled="disabled"></drawer-detail>
    <ul v-show="visibleMenu && showMenu" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li v-if="$auth('centralizedManagement.add')" @click="openDrawerAdd()">新增设备</li>
      <li v-if="$auth('centralizedManagement.add') && visibleShow === 'all'" @click="openDrawerEdit2()">编辑</li>
      <li v-if="$auth('centralizedManagement.add') && visibleShow === 'all'" @click="openDrawerCopy()">复制</li>
      <li v-if="$auth('centralizedManagement.import')" @click="handleImport()">导入设备</li>
      <li v-if="$auth('centralizedManagement.export') && visibleShow === 'all'" @click="derive()">导出当前台账</li>
      <li v-if="$auth('centralizedManagement.del') && visibleShow === 'all'" @click="showDelTip()" style="color: red;">删除</li>
    </ul>
  </a-drawer>
</template>

<script>
import { delEquipment, getEquipmentTableData } from '@/api/equipmentLedger'
import DrawerEdit from '@/views/centralizedManagement/modules/drawerDetailModules/drawerDetail.vue'
import DrawerDetail from '@/views/gasEquipmentLedger/modules/drawerDetail'
export default {
  name: 'ChildrenTableModules',
  components: {
    DrawerEdit,
    DrawerDetail
  },
  props: {
    showMenu: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      visible: false,
      title: '',
      tableData: {
        data: [],
        columns: [],
        loading: false
      },
      scrollY: 300,
      scrollX: 0,
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40'],
        showSizeChanger: true,
        showQuickJumper: true
      },
      // 当前选中的行
      tableCurrRowId: null,
      // 展开的行
      expandedRowKeys: [],
      // 选中的行
      selectedRows: [],
      selectedRowKeys: [],
      visibleMenu: false,
      top: 0,
      left: 0,
      visibleShow: '',
      pModel: {},
      sort: {},
      disabled: false
    }
  },
  created () {

  },
  watch: {
    visibleMenu (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  methods: {
    setpModel (pModel) {
      this.pModel = pModel
      this.getTableData()
    },
    setTitle (title) {
      this.title = title
    },
    setTableColumns (data) {
      this.tableData.columns = data
      this.tableData.columns[1].width = this.tableData.columns[1].width !== 200 ? 285 : this.tableData.columns[1].width
      this.$forceUpdate()
    },
    setScrollX (data) {
      this.scrollX = data
      this.$forceUpdate()
    },
    open (flag) {
      this.visible = flag
    },
    getTableData () {
      const params = {
        pid: this.pModel.id,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        paging: true,
        ...this.sort
      }
      this.tableData.loading = true
      getEquipmentTableData(params).then(res => {
        if (res.status === 0) {
          res.data.list.forEach(item => {
            item.showIndex = true
            delete item.children
          })
          if (res.data.list.length > 0) {
            this.tableData.data = res.data.list
            this.pagination.total = res.data.total
          } else {
            this.tableData.data = []
            this.pagination.total = 0
          }
          this.tableData.loading = false
        } else {
          this.$message.error(res.info.message)
          this.tableData.loading = false
        }
      })
        .catch(err => {
          this.tableData.loading = false
        })
    },
    rowClassName (record, index) {
      return (record.id === this.tableCurrRowId) ? 'yellow' : ''
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.sort.sortName = sorter.field
      if (sorter.order) {
        if (sorter.order === 'ascend') {
          this.sort.sortType = 'asc'
        } else if (sorter.order === 'descend') {
          this.sort.sortType = 'desc'
        }
      } else {
        delete this.sort.sortName
        delete this.sort.sortType
      }
      this.pagination.pageNum = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getTableData()
    },
    // 行点击
    changeRow (record) {
      return {
        on: {
          // 鼠标右键
          contextmenu: (e) => {
            // console.log(e)
            e.preventDefault()
            e.stopPropagation()
            this.selectedRowsData = record
            this.tableCurrRowId = record.id
            if (e.screenY - 103 + 202 > (window.screen.height - 165)) {
              this.top = e.screenY - 103 - 150
            } else {
              this.top = e.screenY - 103
            }
            if (e.pageX > (window.screen.width - 130)) {
              this.left = e.pageX - 111
            } else {
              this.left = e.pageX
            }
            this.visibleShow = 'all'
            this.visibleMenu = true
          },
          // 鼠标双击
          dblclick: (event) => { // 双击行,双击选中
            if (this.$auth('centralizedManagement.edit')) {
              if (!record.dblclickDisabled) {
                this.selectedRowsData = record
                this.disabled = false
                this.$refs.drawerDetail.setTitle('设备详情')
                this.$refs.drawerDetail.setType('edit')
                this.$refs.drawerDetail.setModel(record)
                this.$refs.drawerDetail.open(true)
              }
            }
          },
          // 鼠标单击
          click: (event) => { // 单击行,双击选中
            this.tableCurrRowId = record.id
          }
        }
      }
    },
    // 关闭右键菜单
    closeMenu () {
      this.visibleMenu = false
    },

    // 新增
    openDrawerAdd () {
      this.tableCurrRowId = this.pModel.id
      //  插入子设备
      this.$refs.drawerEdit.setTitle('新增设备')
      this.$refs.drawerEdit.setType('add')
      this.$refs.drawerEdit.setPid(this.pModel.id)
      this.$refs.drawerEdit.setSource('drawer')
      this.$refs.drawerEdit.setPname(this.pModel.name)
      this.$refs.drawerEdit.setDataTabsModel(this.pModel)
      this.$refs.drawerEdit.open(true)
    },
    // 复制
    openDrawerCopy () {
      this.$refs.drawerEdit.setModel(this.selectedRowsData, 'copy')
      this.$refs.drawerEdit.setTitle('新增设备')
      this.$refs.drawerEdit.setSource('drawer')
      this.$refs.drawerEdit.setType('copy')
      this.$refs.drawerEdit.setPname('一级设备')
      this.$refs.drawerEdit.open(true)
    },
    // 编辑
    openDrawerEdit2 () {
      this.$refs.drawerEdit.setModel(JSON.parse(JSON.stringify(this.selectedRowsData)))
      this.$refs.drawerEdit.setTitle('编辑设备')
      this.$refs.drawerEdit.setSource('drawer')
      this.$refs.drawerEdit.setType('edit')
      this.$refs.drawerEdit.open(true)
    },
    // 导入
    handleImport () {
      this.$emit('handleImport')
    },
    // 导出
    derive () {
      this.$emit('derive')
    },
    // 删除提示
    showDelTip () {
      const that = this
      that.$confirm({
        title: (h) => {
          return h('div', {
            domProps: {
              innerHTML: '确定删除该数据吗'
            }
          })
        },
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          that.del()
        },
        onCancel () {

        }
      })
    },
    // 删除
    del () {
      if (this.selectedRowsData.pnode) {
        this.$message.error('当前数据包含子节点，不允许删除')
        return
      }
      const data = {
        ids: this.selectedRowsData.id
      }
      this.btnLoading = true
      delEquipment(data).then(res => {
        if (res.status === 0) {
          this.getTableData()
          this.btnLoading = false
          this.$message.success('删除成功！')
        } else {
          this.btnLoading = false
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.btnLoading = false
      })
    },
    onClose () {
      this.open(false)
    }
  }
}
</script>

<style lang="less" scoped>
.wrapClassName {
  transform: none !important;
  /deep/.ant-drawer-content-wrapper {
    //width: calc(100% - 240px) !important;
    //right: 0;
    .ant-drawer-body {
      height: calc(100% - 55px);
      position: relative;
      padding: 10px;
    }
  }
}

#assetTable_children {
  height: 100%;
  /deep/.ant-spin-nested-loading {
    height: 100%;
    .ant-spin-container {
      height: 100%;
      .ant-table {
        height: calc(100% - 42px);
        .ant-table-content {
          height: 100%;
          .ant-table-scroll {
            height: 100%;
          }
        }
      }
      .ant-pagination {
        margin: 10px 0 0 0;
      }
    }
  }
  // 线颜色修改
  /deep/.ant-table-bordered .ant-table-header > table{
    //border-color: rgba(185, 222, 255, 1) !im;
  }
  /deep/.ant-table-bordered .ant-table-thead > tr > th{
    border-right: 0.8px solid rgba(185, 222, 255, 1);
    border-bottom: 0.8px solid rgba(185, 222, 255, 1);
    background-color: #fff !important;
  }
  /deep/.ant-table-bordered .ant-table-body > table{
    //border-top: 0.8px solid rgba(185, 222, 255, 1);
    //border-left: 0.8px solid rgba(185, 222, 255, 1);
  }
  /deep/.ant-table-bordered .ant-table-tbody > tr > td{
    border-right: 0.8px solid rgba(185, 222, 255, 1);
    border-bottom: 0.8px solid rgba(185, 222, 255, 1);
  }
  /deep/.ant-table-tbody > tr > td{
    //border-bottom: 0.8px solid rgba(185, 222, 255, 1);
  }
  /deep/.ant-table-tbody > tr.ant-table-row-selected td{
    background-color: rgba(225, 225, 225, 0);
  }
  /deep/.ant-table.ant-table-bordered .ant-table-footer{
    border: none !important;
  }
  /deep/.ant-table-bordered.ant-table-fixed-header .ant-table-header > table{
    border-top: 0.8px solid rgba(185, 222, 255, 1);
    //border-bottom: 1.6px solid rgba(185, 222, 255, 1);
  }
  /*有固定行的ant-design-vue 表格滑动样式*/
  /deep/.ant-table-fixed .ant-table-row-hover {
    background: rgb(245, 247, 250) !important;
  }
  /deep/.ant-table-fixed .ant-table-row-hover > td {
    background: rgb(245, 247, 250) !important;
  }
  /*没有固定行的表格个样式*/
  /deep/.ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background-color: rgb(245, 247, 250) !important;
  }
  /deep/.ant-table-body .ant-table-row-hover {
    background: rgb(245, 247, 250) !important;
  }
  /deep/.ant-table-body .ant-table-row-hover > td {
    background: rgb(245, 247, 250) !important;
  }
  /deep/.ant-table-fixed-right {
    height: calc(100% - 7px);
    .ant-table-body-outer {
      height: calc(100% - 36px);
      .ant-table-body-inner {
        max-height: calc(100% - 5px) !important;
        overflow: hidden scroll;
      }
    }
  }
  /deep/.ant-table-fixed-left {
    height: calc(100% - 7px);
    .ant-table-header {
      //border-left: 0.8px solid rgba(185, 222, 255, 1);
    }
    .ant-table-fixed {
      border-left: 0.8px solid rgba(185, 222, 255, 1);
      //border-bottom: 0.8px solid rgba(185, 222, 255, 1) !important;
    }
    .ant-table-body-outer {
      height: calc(100% - 36px);
      .ant-table-body-inner {
        max-height: calc(100% - 5px) !important;
        overflow: hidden scroll;
      }
    }
  }
}

.padding-1-8 {
  padding: 1px 8px !important;
}
.xuIcon {
  margin-right: 5px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(23,145,255,0.7);
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 3px;
  color: #1791FF;
}
.daiIcon {
  margin-right: 5px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(231, 59, 59, 0.50);
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 3px;
  color: rgba(231, 59, 59, 1);
}
.redIcon {
  margin-right: 5px;
  background-color: #E73B3B1A;
  border: 1px solid rgba(231, 59, 59, 0.7);
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 3px;
  color: #E73B3B;
}
.orgIcon {
  margin-right: 5px;
  background: rgba(255,142,59,0.1);
  border: 1px solid rgba(255,142,59,0.7);
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 3px;
  color: #FF8E3B;
}
.blueIcon {
  margin-right: 5px;
  //background: rgba(23,145,255,0.1);
  border: 1px solid rgba(221, 221, 221, 1);
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 3px;
  color: rgba(23, 145, 255, 1);
}

.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: fixed;
  list-style-type: none;
  padding: 5px 4px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 3px 3px 8px 0 rgba(0, 0, 0, 0.3);
  width: 120px;
  text-align: center;
}

.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextmenu li:hover {
  background: rgba(231, 244, 255, 1);
}
</style>
